<template>
  <section v-if="slots.default" class="relative bg-mbzuai-sand-500">
    <button
      v-if="isNavigationOpen"
      type="button"
      class="absolute top-full left-1/2 z-40 block h-screen w-screen -translate-x-1/2 bg-surface-950/50 lg:hidden"
      aria-label="Close division navigation"
      @click="isNavigationOpen = false"
    ></button>

    <ContentContainer
      class="relative z-50 py-2 flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2"
    >
      <div class="w-full lg:w-auto flex justify-between items-center gap-4">
        <p
          v-if="props.division?.divisionType?.name"
          class="justify-start text-sky-900 text-lg font-medium leading-7"
        >
          {{ props.division.divisionType.name }}
        </p>

        <button
          type="button"
          class="lg:hidden bg-mbzuai-sand-300 text-mbzuai-dark-navy-500 rounded-[4.286px] size-[30px] flex items-center justify-center"
          :aria-expanded="isNavigationOpen"
          aria-controls="division-secondary-navigation"
          aria-label="Toggle division navigation"
          @click="isNavigationOpen = !isNavigationOpen"
        >
          <MBZIcon
            :name="isNavigationOpen ? 'times' : 'chevronDown'"
            class="size-2"
          />
        </button>
      </div>

      <nav
        id="division-secondary-navigation"
        class="absolute top-[calc(100%+16px)] left-0 z-50 w-full bg-mbzuai-sand-50 rounded-none p-4 lg:static lg:w-auto lg:bg-transparent lg:p-0 lg:block"
        :class="{ hidden: !isNavigationOpen }"
        aria-label="Division navigation"
      >
        <ul
          class="flex flex-col lg:flex-row justify-start items-start lg:items-center gap-3 lg:gap-4 [&_li]:w-full lg:[&_li]:w-auto [&_a]:w-full lg:[&_a]:w-auto [&_a]:text-base!"
        >
          <slot />
        </ul>
      </nav>
    </ContentContainer>
    <div
      v-if="primaryDivisionColor?.darkVariant"
      class="h-2 lg:h-3"
      :style="{ backgroundColor: primaryDivisionColor.darkVariant }"
    ></div>
    <div
      v-if="primaryDivisionColor?.lightVariant"
      class="h-2 lg:h-3"
      :style="{ backgroundColor: primaryDivisionColor.lightVariant }"
    ></div>
  </section>
</template>

<script setup lang="ts">
const slots = useSlots();
const isNavigationOpen = ref(false);

const setPageScrollLock = (shouldLock: boolean) => {
  if (!import.meta.client) return;

  document.documentElement.classList.toggle('overflow-hidden', shouldLock);
  document.body.classList.toggle('overflow-hidden', shouldLock);
};

type DivisionColor = {
  element?: string;
  darkVariant?: string;
  lightVariant?: string;
  name?: string;
};

type Division = {
  [key: string]: unknown;
  divisionType?: {
    name?: string;
    primaryColor?: DivisionColor[];
  };
};

const props = withDefaults(
  defineProps<{
    division?: Division;
  }>(),
  {
    division: undefined,
  }
);

const primaryDivisionColor = computed(
  () => props.division?.divisionType?.primaryColor?.[0]
);

watch(isNavigationOpen, setPageScrollLock);

onBeforeUnmount(() => {
  setPageScrollLock(false);
});
</script>
